import React from 'react';
import './Avatar.css';
import { AvatarLarge, AvatarSmall } from '../../theme/styles';

export class Avatar extends React.PureComponent {
    render() {
        const {
            initials,
            classOverride,
            showIndicator,
            showMultiple,
            multiOverrideBack,
            multiOverrideFront,
            topNav,
        } = this.props;

        if (showMultiple) {
            return (
                <div className="avatarMulti">
                    <div className={multiOverrideBack || 'avatarMultiBack'} />
                    <div className={multiOverrideFront || 'avatarMultiFront'}>
                        <div style={AvatarSmall}>{initials || ''}</div>
                    </div>
                </div>
            );
        }

        return (
            <div className={classOverride || 'avatar'}>
                {showIndicator && <div className="avatarIndicator" />}
                {topNav ? <div>{initials || ''}</div> : <div style={AvatarLarge}>{initials || ''}</div>}
            </div>
        );
    }
}

export default Avatar;
